<template>
    <HamletTable
        ref="usersTable"
        :columns="columns"
        :fetch="fetch"
        @onRowClick="onRowClick"
    >
        <template #header-label>
            {{ $t('Page(Users):Component(Text):page-label') }}
        </template>

        <template #header-controls>
            <div class="d-flex align-items-center">
                <b-button
                    v-if="$can('execute', 'user-grid-reindex-current-subscriber-users')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-0 mr-1"
                    :disabled="isReindexing"
                    title="Reindex current subscriber users"
                    @click="reindexCurrentSubscriberUsers"
                >
                    <feather-icon icon="RotateCwIcon" />
                    <span class="ml-50">Reindex</span>
                </b-button>
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-0 btn-icon"
                    @click="addUser"
                >
                    <feather-icon icon="PlusIcon" />
                </b-button>
            </div>
        </template>

        <template #cell-organizations="data">
            {{ renderOrganizations(data.item.organizations) }}
        </template>

        <template #cell-roles="data">
            {{ renderRoles(data.item.roles) }}
        </template>
    </HamletTable>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { HamletTable } from '@core/components/common'
import { InternalToolsApi, UserApi } from '@core/api'
import Ripple from 'vue-ripple-directive'
import backendResponse from '@core/mixins/ui/backend-response'

export default {
    components: {
        BButton,
        HamletTable,
    },
    directives: { Ripple },
    mixins: [backendResponse],
    data() {
        return {
            isReindexing: false,
            reindexRefreshTimer: null,
            columns: [
                {
                    key: 'name',
                    label: this.$t('Page(Users):Component(Text):column-name'),
                },
                {
                    key: 'email',
                    label: this.$t('Page(Users):Component(Text):column-email'),
                },
                {
                    key: 'organizations',
                    label: this.$t('Page(Users):Component(Text):column-organizations'),
                },
                {
                    key: 'roles',
                    label: this.$t('Page(Users):Component(Text):column-roles'),
                },
            ],
        }
    },
    beforeDestroy() {
        if (this.reindexRefreshTimer) {
            clearTimeout(this.reindexRefreshTimer)
        }
    },
    methods: {
        renderOrganizations(organizations) {
            if (organizations.length > 3) {
                return `${organizations.slice(0, 3).map(o => o.title).join(', ')}, ...`
            }
            return organizations.map(o => o.title).join(', ')
        },
        renderRoles(roles) {
            if (roles.length > 3) {
                return `${roles.slice(0, 3).join(', ')}, ...`
            }
            return roles.join(', ')
        },
        onRowClick(user) {
            this.$router.push({
                name: 'administration-user-card',
                params: {
                    id: user.id,
                },
            })
        },
        addUser() {
            this.$router.push({ name: 'administration-user-add' })
        },
        reindexCurrentSubscriberUsers() {
            this.isReindexing = true
            InternalToolsApi.user.currentSubscriber
                .reindexUsers()
                .then(() => {
                    this.showDefaultSuccessMessage('User reindex has been queued')
                    this.reindexRefreshTimer = setTimeout(() => {
                        this.$refs.usersTable.refresh()
                        this.isReindexing = false
                        this.reindexRefreshTimer = null
                    }, 5000)
                })
                .catch(e => {
                    this.isReindexing = false
                    this.handleBackendError(e)
                })
        },
        fetch(config, cb) {
            UserApi.getUsers([], {}, config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items)
            })
        },
    },
}
</script>
